import type { CSSProperties, ReactNode } from 'react'

interface AppShellProps {
  accent: string
  accentSoft: string
  children: ReactNode
  settingsMenu?: ReactNode
  saveError?: string | null
  saveRetryLabel?: string
  onRetrySave?: () => void
  onDismissSaveError?: () => void
}

export function AppShell({
  accent,
  accentSoft,
  children,
  settingsMenu,
  saveError,
  saveRetryLabel,
  onRetrySave,
  onDismissSaveError
}: AppShellProps): JSX.Element {
  return (
    <div
      className="app-shell"
      style={
        {
          '--accent': accent,
          '--accent-soft': accentSoft
        } as CSSProperties
      }
    >
      <div className="background-orb orb-one" />
      <div className="background-orb orb-two" />
      {saveError && (
        <div className="save-error-banner" role="alert">
          {saveError}
          {onRetrySave && (
            <button type="button" onClick={onRetrySave}>
              {saveRetryLabel}
            </button>
          )}
          {onDismissSaveError && (
            <button type="button" onClick={onDismissSaveError}>
              ×
            </button>
          )}
        </div>
      )}
      {settingsMenu}
      {children}
    </div>
  )
}
